export class DefaultFilter {
    maxPrice: any;
    minPrice: any;
    discount: any;
    dispatch: any;
}